import React from 'react';
import MeuPedido from '../../Meu_Pedido/Meu_Pedido';
import NavBarTop from '../../NavBar_Top/NavBar_Top';
import Rodape from '../../Rodape/Rodape';
import { Grid, Card } from '@mui/material';

function LinkPagamento(props) {

  console.log("LPGTO", props);
  const pedidoEfetuado = props?.props;

  return (
    <>
        <NavBarTop />
        <Grid container spacing={2}>
          <Grid item xs={12}>
              xs=12
          </Grid>
          <Grid item xs={12}>
            xs=12
          </Grid>
          <Grid item xs={12}>
            xs=12
          </Grid>
        </Grid>
        <Rodape />
    </>
  )
}

export default LinkPagamento;